<template>
    <header id="masthead" role="banner">
        <nav id="user-nav" class="navbar navbar-dark navbar-expand-md">
            <div class="container-fluid">
                <div class="navbar-brand">
                    <a id="illinois-logo-link" href="http://illinois.edu">
                        <span id="illinois-logo-text" class="sr-only">University of Illinois at Urbana-Champaign</span>
                        <svg version="1.1" id="illinois-logo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 56.2 81" style="enable-background:new 0 0 56.2 81;" xml:space="preserve">
                            <title id="illinois-logo-title">University of Illinois at Urbana-Champaign logo</title>
                            <desc id="illinois-logo-desc">The iconic orange block letter I</desc>
                            <path class="illinois-logo-border" d="M55.3,22.8V1.7H1.2v21.1h12v36.1h-12V80h54.2V58.9h-12V22.8H55.3z M43.3,61.9h9v15H4.2v-15h9c1.7,0,3-1.3,3-3 V22.8c0-1.7-1.3-3-3-3h-9v-15h48.1v15h-9c-1.7,0-3,1.3-3,3v36.1C40.3,60.6,41.6,61.9,43.3,61.9z" />
                            <path class="illinois-logo-body" d="M43.3,19.8h9v-15H4.2v15h9c1.7,0,3,1.3,3,3v36.1c0,1.7-1.3,3-3,3h-9v15h48.1v-15h-9c-1.7,0-3-1.3-3-3V22.8 C40.3,21.1,41.6,19.8,43.3,19.8z" />
                        </svg>
                    </a>
                    <h1 class="site-id d-inline-block">
                        <router-link to="/">my<span class="site-id-bold">Illini</span></router-link>
                    </h1>
                    
                </div>
                <button id="mobile-menu-button" class="navbar-toggler" type="button" data-toggle="collapse" data-target=".mobile-menu" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle primary navigation" @click="collapsePanel">
                    <span class="icon-user"></span>
                </button>
                <div id="user-nav-menu" class="collapse navbar-collapse justify-content-end mobile-menu" role="navigation" aria-labelledby="primary-nav-header">
                    <h2 id="primary-nav-header" class="sr-only">Primary Menu</h2>
                    <div class="profile-info navbar-text" v-if="userInfo.isAuthenticated">
                        <figure class="profile-image figure">   
                            <img :src="profileImage" alt="Profile Image" class="figure-img img-fluid rounded-circle" />
                        </figure>
                        <p class="user-title">
                            Hi {{getDisplayName}}!
                        </p>
                        
                    </div>
                    <ul class="navbar-nav nav-fill" v-if="userInfo.isAuthenticated">
                        <li class="nav-item">
                            <router-link to="/" class="nav-link" v-on:click.native="collapsePanel" data-target=".mobile-menu">Dashboard</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/Profile" class="nav-link" v-on:click.native="collapsePanel" data-target=".mobile-menu">Profile</router-link>
                        </li>

                        <li class="nav-item"><a :href="logoutUrl" class="nav-link" @click="logout">Log Out</a></li>

                    </ul>
                </div>
            </div>
        </nav>
    </header>
</template>

<script>
    import jwtService from "@/common/jwt.service";
    //we probably need to use vuex to get state which will get us all of these shared data elements
    export default {
        name: 'Header',
        //props: {},
        /*methods: {
            getProfileImage: function() {
                return "images/__placeholder__.jpg";
            }
        },*/
        //computed method results are cached unless using reactive items (items from the data), methods are always recalculated
        computed: {
            userInfo() {
                return this.$store.state.userInfo;
            },
            profileImage() {
                return this.$store.state.profileImage;
            },
            getDisplayName: function() {
                return this.userInfo.isImpersonating ? this.userInfo.displayName + ' (Impersonating)' : this.userInfo.displayName;
            },
            logoutUrl: function() {
               return `/Auth/Logoff`     
            }
        },
        methods: {
            logout() {
                jwtService.destroyToken();
                console.log("destroyed");
            }
        },
        mounted() {
            if (this.$store.state.imageIsLoaded == 0 && this.$store.state.userInfo.isAuthenticated == true) {
                this.$store.dispatch("getProfileImage");
            }
        }
        /*
        filters: {
            //add any data display manipulation logic here
        },*/

    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>